import script from "./CategoriesTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriesTemplate.vue?vue&type=script&setup=true&lang=js"

import "./CategoriesTemplate.vue?vue&type=style&index=0&id=3e5f08e9&lang=scss"
import "./CategoriesTemplate.vue?vue&type=style&index=1&id=3e5f08e9&lang=scss&scoped=true"

import exportComponent from "F:\\ubuntuBK\\sombardc\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e5f08e9"]])

export default __exports__